import { faPlus, faRobot } from "@fortawesome/pro-regular-svg-icons";

import { EmptyState } from "src/design-system/EmptyState";

type Props = {
  immutable: boolean;
  handleSelectAgent: () => void;
  type: "agent-selection" | "input-mapping";
};

const HEADLINES = {
  "agent-selection": "Select Agent",
  "input-mapping": "No Agent selected",
};

const DESCRIPTIONS = {
  "agent-selection": "Select an Agent to start configuring this node",
  "input-mapping": "Select an Agent to complete mapping",
};

export const NoAgentSelected: React.FC<Props> = ({
  immutable,
  handleSelectAgent,
  type,
}) => (
  <EmptyState
    actionButton={{
      label: "Select Agent",
      icon: faPlus,
      onClick: handleSelectAgent,
      isDisabled: immutable,
    }}
    dataLoc="no-agent-selected"
    description={DESCRIPTIONS[type]}
    headline={HEADLINES[type]}
    icon={faRobot}
  />
);
